module.exports = __webpack_public_path__ + "img/loader-pet.4622f5bb.gif";